import Vue from 'vue';
import Router from 'vue-router';
import Schedules from '../components/Schedules.vue'
import Statistics from '../components/Statistics.vue'
// import Tickets from '../components/Tickets.vue'
import Help from '../components/Help.vue'
import Login from '../components/Login.vue'
import store from '../store/index.js'
import MultiLanguage from 'vue-multilanguage';
import language from '../lang/language'

function requireAuth(to, from, next){
  if (store.getters.getUser === null) {
    next('/Login');
  } else {
    next();
  }
}

Vue.use(Router);
Vue.use(MultiLanguage, language);

export default new Router({
  routes: [
    {
      path: '/Schedules',
      name: 'Schedules',
      component: Schedules,
      beforeEnter: requireAuth
    }, 
    {
      path: '/Statistics',
      name: 'Statistics',
      component: Statistics,
      beforeEnter: requireAuth
    },
    {
      path: '/Help',
      name: 'Help',
      component: Help,
      beforeEnter: requireAuth
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login,
      // beforeEnter: requireAuth // stack overflow
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }

});


// WEBPACK FOOTER //
// ./src/router/router.js